import {useGlobalState} from "../../global-config/GlobalConfig";

export function useGetInDevnet(): boolean {
  const [state] = useGlobalState();
  return state.network_name === "devnet";
}
